import React from "react"

import QuoteSummaryLineItems from "~components/shared/quote/quote-summary-line-items"
import Divider from "~components/shared/divider"
import QuoteSummaryPrices from "~components/shared/quote/quote-summary-prices"
import QuoteSummaryDiscount from "~components/shared/quote/quote-summary-discount"
import QuoteSummaryProcessingFeeWarning from "~components/shared/quote/quote-summary-processing-fee-warning"
import type { QuoteInterfaceFieldsFragment } from "~graphql/generated/graphql"
import type { OnEditPackageClickFunc } from "~components/shared/quote/quote-package-buttons"

type QuoteWithOptionalId = QuoteInterfaceFieldsFragment & { id?: string }

interface Props {
    readonly quote?: QuoteWithOptionalId | null
    readonly shouldShowDeleteButtons?: boolean
    readonly onEditPackageClick?: OnEditPackageClickFunc
    readonly shouldShowProcessingFeeWarning?: boolean
}

export default function QuoteSummary({
    quote,
    shouldShowDeleteButtons,
    onEditPackageClick,
    shouldShowProcessingFeeWarning = false,
}: Props) {
    const paymentSummary = quote?.payment_summary

    if (!paymentSummary) return null

    return (
        <>
            <Divider margin />
            <QuoteSummaryLineItems
                quoteOrBooking={quote}
                quoteId={quote.id}
                lineItems={paymentSummary.line_items}
                shouldShowDeleteButtons={shouldShowDeleteButtons}
                onEditPackageClick={onEditPackageClick}
            />
            <QuoteSummaryDiscount
                coupon={quote.coupon}
                discount={quote.discount}
            />
            <Divider margin />
            <QuoteSummaryPrices prices={paymentSummary.prices} />
            <Divider margin />
            <QuoteSummaryPrices prices={paymentSummary.totals} isTotals />
            <QuoteSummaryProcessingFeeWarning
                shouldRender={shouldShowProcessingFeeWarning}
            />
        </>
    )
}
